export enum GlobalEventEnum {
  UPDATE_NAVBAR_STATUS = 'updateNavbarStatus',
}
